module.exports = __webpack_public_path__ + "img/square_wechat_group.195b42cb.png";